import React, { Component } from 'react'
import {DropzoneDialog} from 'material-ui-dropzone'
import { storage, db } from '../../firebase'
 
export default class DropzoneAreaSeccion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            files: [],
            ref:"",
            srcImagen:"",
            Imagen:"",
        };
    }
 
    handleClose() {
        this.setState({
            open: false
        });
    }
 
    async handleSave(files) {
        //Saving files to state for further use and closing Modal.
        this.setState({
            files: files,
            open: false
        });
        // console.log(files)
        try {

            const newRef = storage.ref(`documents/billing/validacion/${this.props.documentId}/`).child(`${this.props.documentId}-0`); // nombre del archivo
            this.setState({ref:newRef})
            await newRef.put(files[0]); 
            let urlImagen = await newRef.getDownloadURL()
            this.setState({srcImagen:urlImagen})
            // console.log('la ul de la imagen es: ' + urlImagen);
            // console.log('actualizar imagen')
            await db.collection(`${process.env.REACT_APP_COL_SUMARIES}`).doc(`${this.props.documentId}`).update({
                "urlTransferEvidence":urlImagen,
              });

        } catch (error) {
            // console.log(error);
        }
    };
    
 
    handleOpen() {
        this.setState({
            open: true,
        });
    }
 
    render() {
        return (
            <div>
                <button className="btn btn-ebiex btn-globalhover m-1" onClick={this.handleOpen.bind(this)}>
                  Subir documento
                </button>
                <DropzoneDialog
                    open={this.state.open}
                    onSave={this.handleSave.bind(this)}
                    acceptedFiles={['image/jpeg', 'image/png', 'image/bmp']}
                    showPreviews={true}
                    maxFileSize={5000000}
                    onClose={this.handleClose.bind(this)}
                />
            </div>
        );
    }
}